module.exports = __webpack_public_path__ + "img/kocorp_75_38.eb825883.png";